// src/pages/HomePage.js
import React, { lazy, Suspense, useEffect, useState } from "react";
import EntryModal from "../components/EntryModal";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import CategoryCards from "../components/CategoryCards";
import SaleBanner from "../components/SaleBanner";
import CategoryHero from "../components/CategoryHero";
import FeaturedCategories from "../components/FeaturedCategories";
import CategoryCarousel from "../components/CategoryCarousel";
import Footer from "../components/Footer";
import ScrollingTicker from "../components/ScrollingTicker";
import CartDrawer from "../components/CartDrawer";
import AddedToBagToast from "../components/AddedToBagToast";
import { useSeo } from "../hooks/useSeo";

const AccessoriesSection = lazy(() =>
  import("../components/AccessoriesSection")
);
const FlatsMiniSection = lazy(() =>
  import("../components/FlatsMiniSection")
);
const LuxuryVideoShowcase = lazy(() =>
  import("../components/LuxuryVideoShowcase")
);

function HomePage() {
  /* ================= SEO (SAFE + LIONS BRAND) ================= */
  useSeo(
    "home",
    null,
    typeof window !== "undefined"
      ? {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "@id": `${window.location.origin}/#organization`,
              name: "Lions",
              url: window.location.origin,
              logo: `${window.location.origin}/logo512.png`,
              image: `${window.location.origin}/logo512.png`,
              sameAs: [
                "https://www.instagram.com/",
                "https://www.facebook.com/"
              ]
            },
            {
              "@type": "WebSite",
              "@id": `${window.location.origin}/#website`,
              url: window.location.origin,
              name: "Lions | Tactical, Hunting & Outdoor Gear",
              publisher: {
                "@id": `${window.location.origin}/#organization`
              },
              potentialAction: {
                "@type": "SearchAction",
                target: `${window.location.origin}/products?q={search_term_string}`,
                "query-input": "required name=search_term_string"
              }
            }
          ]
        }
      : null
  );

  /* ================= ENTRY MODAL ================= */
  const [showEntry, setShowEntry] = useState(false);

  const [showWhatsappCTA, setShowWhatsappCTA] = useState(false);

useEffect(() => {
  const t = setTimeout(() => setShowWhatsappCTA(true), 1000);
  return () => clearTimeout(t);
}, []);


 useEffect(() => {
  const forceLogin = localStorage.getItem("esill-open-login");

  // 🔥 ONLY open when user explicitly clicked "Login"
  if (forceLogin) {
    setShowEntry(true);
  }
}, []);

 const closeEntry = () => {
  localStorage.removeItem("esill-open-login");
  setShowEntry(false);
};



  return (
    <div
  className="
    w-full min-h-screen flex flex-col
    bg-[#0F1A12] text-white
    overflow-x-hidden
  "
>

      {/* GLOBAL */}
      <TopBanner />
      <MainHeader
        onMenuOpen={() => {}}
        onSearchOpen={() => {}}
        onBagOpen={() => {}}
      />
      <CartDrawer />
      <AddedToBagToast />

      {/* CONTENT */}
      <CategoryCards />
      <SaleBanner />
      <CategoryCarousel />
      <CategoryHero />
      <FeaturedCategories />

      <Suspense fallback={null}>
        <AccessoriesSection />
        <FlatsMiniSection />
        <LuxuryVideoShowcase />
      </Suspense>

      <ScrollingTicker />
      <Footer className="mt-auto" />

      {/* ENTRY */}
      <EntryModal isOpen={showEntry} onClose={closeEntry} />
      {/* WHATSAPP CTA */}
{showWhatsappCTA && (
  <div className="fixed z-[9999] bottom-20 right-5 flex flex-col items-center gap-2">
    <button
      onClick={() => setShowWhatsappCTA(false)}
      className="w-7 h-7 rounded-full bg-white text-black text-sm"
    >
      ×
    </button>

    <a
      href="https://wa.me/96181220255"
      target="_blank"
      rel="noreferrer"
      className="w-14 h-14 rounded-full flex items-center justify-center"
      style={{ backgroundColor: "#25D366" }}
    >
      <img
        src="/icons/whatsapp.png"
        alt="WhatsApp"
        className="w-7 h-7"
      />
    </a>
  </div>
)}
    </div>
  );
}

export default HomePage;
